import React from 'react';
import styles from 'pages/studyOverview/containers/StudyOverview/OverviewWidget.scss';
import { Link } from 'react-router';
import WidgetCount from 'pages/studyOverview/containers/StudyOverview/WidgetCount';

function OverviewWidget(props) {
    const { 
        label, text, errorText, widgetPath, primaryCount, secondaryCount, 
        isPrimaryAlert, isSecondaryAlert, primaryLabel, 
        secondaryLabel, isLoadingExpectedDocuments, isError 
    } = props;

    return (
        <div className={styles.widget} data-cy="OverviewWidget">
            <div className={styles.infoContainer}>
                <h1 className={styles.widgetHeader} data-cy="OverviewWidget-label">{label}</h1>
                <p className={styles.widgetText} data-cy="OverviewWidget-errorText">{isError ? errorText:text}</p>
                <Link to={widgetPath} className={styles.actionLink}>VIEW DETAILS</Link>
            </div>
            <div className={styles.widgetContainer}>
                {isPrimaryAlert && 
                    <WidgetCount
                        count={primaryCount}
                        label={primaryLabel}
                        isLoadingExpectedDocuments={isLoadingExpectedDocuments}
                    />
                }
                {isSecondaryAlert &&
                    <WidgetCount
                        count={secondaryCount}
                        label={secondaryLabel}
                        isLoadingExpectedDocuments={isLoadingExpectedDocuments}
                    />
                }
            </div>

        </div>
    );
}

export default OverviewWidget;
